import { lazy } from "react";
const RBLamination = lazy(() => import("./rblamination"));

const rblaminationRoutes = [
{
    path: '/rblamination',
    component: RBLamination,
}
];

export default rblaminationRoutes;